<h3 mat-dialog-title>Vessel redundancy group</h3>

<mat-dialog-content>

    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Name</mat-label>
            <input matInput type="text" name="vesselMachineryName" [(ngModel)]="redundancyGroup.name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Description</mat-label>
            <textarea matInput type="text" name="Description" [(ngModel)]="redundancyGroup.description"></textarea>
        </mat-form-field>
    </form>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="redundancyGroup" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>